/**
 * Frontend-facing settlement enum values. The store maps backend API strings
 * (see ApiFeeCalculationMethod / ApiExpenseArrangement in settlementTypes.ts)
 * to these before they reach the UI.
 */
export const FEE_METHOD = {
  GROSS: 'Gross',
  NET: 'Net',
} as const;

export const EXPENSE_ARRANGEMENT = {
  FIRM: 'Firm',
  CLIENT: 'Client',
  ABSORBED: 'Absorbed',
} as const;

/** Backend enum values sent/received over the wire (see ApiFeeCalculationMethod / ApiExpenseArrangement). */
export const API_FEE_METHOD = {
  GROSS: 'gross',
  NET: 'net',
} as const;

export const API_EXPENSE_ARRANGEMENT = {
  FIRM_ADVANCES: 'firmAdvances',
  CLIENT_PAYS: 'clientPays',
  FIRM_ABSORBS: 'firmAbsorbs',
} as const;

/** Step 5 "Matters:" column — how many matter names render before "+N more". */
export const VISIBLE_MATTER_NAME_LIMIT = 2;
